exports = module.exports = require("../../../node_modules/_css-loader@0.28.7@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@-webkit-keyframes preloader-spin{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes preloader-spin{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.footer-secondary{padding:.4rem;height:2.8rem;position:absolute;width:100%;bottom:2.8rem}.footer-secondary:before{content:\"\";position:absolute;left:0;top:0;bottom:auto;right:auto;height:1px;width:100%;background-color:#e7e7e7;display:block;z-index:1;-webkit-transform-origin:50% 0;transform-origin:50% 0}@media only screen and (-webkit-min-device-pixel-ratio:2){.footer-secondary:before{-webkit-transform:scaleY(.5);transform:scaleY(.5)}}.footer-secondary:after{display:none}.footer-secondary~.page-content{bottom:5.6rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.7@css-loader?minimize!./node_modules/_vue-loader@13.5.0@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6091530d","scoped":false,"hasInlineConfig":false}!./node_modules/_less-loader@4.0.5@less-loader/dist/cjs.js!./node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=styles&index=0!./src/components/footer/second.vue
// module id = GERB
// module chunks = 1